<template>
    <div class="show-detail-dates show-detail-snapshot" v-if="show">
        <ul>
            <li>
                <span>
                    <h5>First Preview</h5>
                    <p v-html="firstPreview"/>
                </span>
            </li>
            <li>
                <span>
                    <h5>Opening Date</h5>
                    <p v-html="opening"/>
                </span>
            </li>
            <li>
                <span>
                    <h5>Closing Date</h5>
                    <p v-html="closing"/>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import { formatDate } from 'src/util/helpers';

export default {
    computed: {
        show() {
            return this.$store.getters['shows/show'](this.$route.params.show);
        },
        firstPreview() {
            if (this.show.first_preview_date) {
                if (typeof this.show.first_preview_date !== 'string') {
                    return '&nbsp;';
                }

                return formatDate(this.show.first_preview_date);
            }

            return 'Upcoming';
        },
        opening() {
            if (this.show.opening_date) {
                if (typeof this.show.opening_date !== 'string') {
                    return '&nbsp;';
                }

                return formatDate(this.show.opening_date);
            }

            if (!this.show.first_preview_date) {
                return 'Upcoming';
            }

            return 'In Previews';
        },
        closing() {
            if (this.show.closing_date) {
                if (typeof this.show.closing_date !== 'string') {
                    return '&nbsp;';
                }

                return formatDate(this.show.closing_date);
            }

            if (!this.show.first_preview_date) {
                return 'Upcoming';
            }

            return 'Currently Running';
        },
    },
};
</script>
